// import { upgradeCaPlansDictionary as upgradeCanadaPlansDictionary } from "../../core/dictionary/upgrade-ca-plans.js"; // needed later
import { searchPhraseDictionary } from "./global-country-dictionary";

//  VITE NEW IMPORT
export const globalCountryDetailsDictionary = {
  us_import: {
    // US Import
    country_small: "us",
    country_caps: "US",
    product_id: "trademo_US",
    country_CamelCase: "United States",
    countryCode: "US",
    countryCodeFlag: "US",
    countryShortHand: "US",
    compareProduct: "_us_",
    countryType: "import",
    manyCountryType: "imports",
    countryTypeCode: "I",
    redirectionID: "us_imports",
    analyticsCountryID: "US-IMPORTS",
    localProduct: "intel-us",
    countryUrlDashboard: "country=us",
    countryPathName: "search-shipments",
    countryName: "US Imports (Maritime)",
    coProductsUrl: "product-trends",
    continent: "NA",
    dataSource: "us imports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },
      { value: searchPhraseDictionary.logistics, label: "Logistics", placeHolder: "Search upto 20 Logistics by name or SCAC", pillColor: "#178add" },

      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
      { value: searchPhraseDictionary.ports, label: "Ports", placeHolder: "Search upto 20 Ports’s name", pillColor: "#de1368" },
    ],
  },
  us_export: {
    // US Export
    country_small: "us",
    country_caps: "US",
    product_id: "trademo_US",
    country_CamelCase: "United States",
    countryCode: "US",
    countryCodeFlag: "US",
    countryShortHand: "US",
    compareProduct: "_us_",
    countryType: "export",
    manyCountryType: "exports",
    countryTypeCode: "E",
    redirectionID: "us_exports",
    analyticsCountryID: "US-EXPORTS",
    localProduct: "intel-us",
    countryUrlDashboard: "country=us",
    countryPathName: "us-exports-search",
    countryName: "US Exports (Maritime)",
    continent: "NA",
    dataSource: "us exports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },
      { value: searchPhraseDictionary.logistics, label: "Logistics", placeHolder: "Search upto 20 Logistics by name or SCAC", pillColor: "#178add" },

      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
      { value: searchPhraseDictionary.ports, label: "Ports", placeHolder: "Search upto 20 Ports’s name", pillColor: "#de1368" },
    ],
  },
  uk_import: {
    // UK Import
    country_small: "united kingdom",
    country_caps: "UNITED KINGDOM",
    product_id: "trademo_UK",
    country_CamelCase: "United Kingdom",
    countryCode: "GB",
    countryCodeFlag: "GB",
    countryShortHand: "UK",
    compareProduct: "_uk_",
    countryType: "import",
    manyCountryType: "imports",
    countryTypeCode: "I",
    redirectionID: "uk_imports",
    analyticsCountryID: "UK-IMPORTS",
    localProduct: "intel-uk",
    countryUrlDashboard: "country=uk",
    countryPathName: "uk-search-import",
    countryName: "UK Imports",
    continent: "EU",
    dataSource: "uk imports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
    ],
  },
  uk_export: {
    // UK Export
    country_small: "united kingdom",
    country_caps: "UNITED KINGDOM",
    product_id: "trademo_UK",
    country_CamelCase: "United Kingdom",
    countryCode: "GB",
    countryCodeFlag: "GB",
    countryShortHand: "UK",
    compareProduct: "_uk_",
    countryType: "export",
    manyCountryType: "exports",
    countryTypeCode: "E",
    redirectionID: "uk_exports",
    analyticsCountryID: "UK-EXPORTS",
    localProduct: "intel-uk",
    countryUrlDashboard: "country=uk",
    countryPathName: "uk-search-export",
    countryName: "UK Exports",
    continent: "EU",
    dataSource: "uk exports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },
    ],
  },
  pa_import: {
    // Panama Import
    country_small: "panama",
    country_caps: "PANAMA",
    product_id: "trademo_PA",
    country_CamelCase: "Panama",
    countryCode: "PA",
    countryCodeFlag: "PA",
    compareProduct: "_pa_",
    countryType: "import",
    manyCountryType: "imports",
    countryTypeCode: "I",
    redirectionID: "pa_imports",
    analyticsCountryID: "PANAMA-IMPORTS",
    localProduct: "intel-panama",
    countryUrlDashboard: "country=panama",
    countryPathName: "panama-search-import",
    countryName: "Panama Imports",
    continent: "CSA",
    dataSource: "panama imports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
    ],
  },
  pa_export: {
    // Panama Export
    country_small: "panama",
    country_caps: "PANAMA",
    product_id: "trademo_PA",
    country_CamelCase: "Panama",
    countryCode: "PA",
    countryCodeFlag: "PA",
    compareProduct: "_pa_",
    countryType: "export",
    manyCountryType: "exports",
    countryTypeCode: "E",
    redirectionID: "pa_exports",
    analyticsCountryID: "PANAMA-EXPORTS",
    localProduct: "intel-panama",
    countryUrlDashboard: "country=panama",
    countryPathName: "panama-search-export",
    countryName: "Panama Exports",
    continent: "CSA",
    dataSource: "panama exports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name", pillColor: "#07710b" },

      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
    ],
  },
  ch_import: {
    // Chile Import
    country_small: "chile",
    country_caps: "CHILE",
    product_id: "trademo_CH",
    country_CamelCase: "Chile",
    countryCode: "CH",
    countryCodeFlag: "CL",
    compareProduct: "_ch_",
    countryType: "import",
    manyCountryType: "imports",
    countryTypeCode: "I",
    redirectionID: "ch_imports",
    analyticsCountryID: "CHILE-IMPORTS",
    localProduct: "intel-chile",
    countryUrlDashboard: "country=chile",
    countryPathName: "chile-search-import",
    countryName: "Chile Imports",
    continent: "CSA",
    dataSource: "chile imports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name", pillColor: "#2a3791" },

      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
      { value: searchPhraseDictionary.ports, label: "Ports", placeHolder: "Search upto 20 Ports’s name", pillColor: "#de1368" },
    ],
  },
  ch_export: {
    // Chile Export
    country_small: "chile",
    country_caps: "CHILE",
    product_id: "trademo_CH",
    country_CamelCase: "Chile",
    countryCode: "CH",
    countryCodeFlag: "CL",
    compareProduct: "_ch_",
    countryType: "export",
    manyCountryType: "exports",
    countryTypeCode: "E",
    redirectionID: "ch_exports",
    analyticsCountryID: "CHILE-EXPORTS",
    localProduct: "intel-chile",
    countryUrlDashboard: "country=chile",
    countryPathName: "chile-search-export",
    countryName: "Chile Exports",
    continent: "CSA",
    dataSource: "chile exports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name", pillColor: "#07710b" },

      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
      { value: searchPhraseDictionary.ports, label: "Ports", placeHolder: "Search upto 20 Ports’s name", pillColor: "#de1368" },
    ],
  },
  uy_import: {
    // Uruguay Import
    country_small: "uruguay",
    country_caps: "URUGUAY",
    product_id: "trademo_UY",
    country_CamelCase: "Uruguay",
    countryCode: "UY",
    countryCodeFlag: "UY",
    compareProduct: "_uy_",
    countryType: "import",
    manyCountryType: "imports",
    countryTypeCode: "I",
    redirectionID: "uy_imports",
    analyticsCountryID: "URUGUAY-IMPORTS",
    localProduct: "intel-uruguay",
    countryUrlDashboard: "country=uruguay",
    countryPathName: "uruguay-search-import",
    countryName: "Uruguay Imports",
    continent: "CSA",
    dataSource: "uruguay imports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name, Zip Code, City or Address", pillColor: "#2a3791" },

      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.ports, label: "Ports", placeHolder: "Search upto 20 Ports’s name", pillColor: "#de1368" },
    ],
  },
  uy_export: {
    // Uruguay Export
    country_small: "uruguay",
    country_caps: "URUGUAY",
    product_id: "trademo_UY",
    country_CamelCase: "Uruguay",
    countryCode: "UY",
    countryCodeFlag: "UY",
    compareProduct: "_uy_",
    countryType: "export",
    manyCountryType: "exports",
    countryTypeCode: "E",
    redirectionID: "uy_exports",
    analyticsCountryID: "URUGUAY-EXPORTS",
    localProduct: "intel-uruguay",
    countryUrlDashboard: "country=uruguay",
    countryPathName: "uruguay-search-export",
    countryName: "Uruguay Exports",
    continent: "CSA",
    dataSource: "uruguay exports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },

      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.ports, label: "Ports", placeHolder: "Search upto 20 Ports’s name", pillColor: "#de1368" },
    ],
  },
  co_import: {
    // Colombia Import
    country_small: "colombia",
    country_caps: "COLOMBIA",
    product_id: "trademo_CO",
    country_CamelCase: "Colombia",
    countryCode: "CO",
    countryCodeFlag: "CO",
    compareProduct: "_co_",
    countryType: "import",
    manyCountryType: "imports",
    countryTypeCode: "I",
    redirectionID: "co_imports",
    analyticsCountryID: "COLOMBIA-IMPORTS",
    localProduct: "intel-colombia",
    countryUrlDashboard: "country=colombia",
    countryPathName: "colombia-search-import",
    countryName: "Colombia Imports",
    isMonthPicker: true,
    continent: "CSA",
    dataSource: "colombia imports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search using Consignee’s name or Consignee NIT Number", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search using Shipper’s name or address", pillColor: "#07710b" },

      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search using Harmonised System Codes such as 0805: Citrus fruit, fresh or dried", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.ports, label: "Ports", placeHolder: "Search upto 20 Ports’s name", pillColor: "#de1368" },
    ],
  },
  co_export: {
    // Colombia Export
    country_small: "colombia",
    country_caps: "COLOMBIA",
    product_id: "trademo_CO",
    country_CamelCase: "Colombia",
    countryCode: "CO",
    countryCodeFlag: "CO",
    compareProduct: "_co_",
    countryType: "export",
    manyCountryType: "exports",
    countryTypeCode: "E",
    redirectionID: "co_exports",
    analyticsCountryID: "COLOMBIA-EXPORTS",
    localProduct: "intel-colombia",
    countryUrlDashboard: "country=colombia",
    countryPathName: "colombia-search-export",
    countryName: "Colombia Exports",
    isMonthPicker: true,
    continent: "CSA",
    dataSource: "colombia exports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or NIT Number", pillColor: "#07710b" },

      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.ports, label: "Ports", placeHolder: "Search upto 20 Ports’s name", pillColor: "#de1368" },
    ],
  },
  ec_import: {
    // Ecuador Import
    country_small: "ecuador",
    country_caps: "ECUADOR",
    product_id: "trademo_EC",
    country_CamelCase: "Ecuador",
    countryCode: "EC",
    countryCodeFlag: "EC",
    compareProduct: "_ec_",
    countryType: "import",
    manyCountryType: "imports",
    countryTypeCode: "I",
    redirectionID: "ec_imports",
    analyticsCountryID: "ECUADOR-IMPORTS",
    localProduct: "intel-ecuador",
    countryUrlDashboard: "country=ecuador",
    countryPathName: "ecuador-search-import",
    countryName: "Ecuador Imports",
    continent: "CSA",
    dataSource: "ecuador imports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee's name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },

      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
      { value: searchPhraseDictionary.ports, label: "Ports", placeHolder: "Search upto 20 Ports’s name", pillColor: "#de1368" },
    ],
  },
  ec_export: {
    // Ecuador Export
    country_small: "ecuador",
    country_caps: "ECUADOR",
    product_id: "trademo_EC",
    country_CamelCase: "Ecuador",
    countryCode: "EC",
    countryCodeFlag: "EC",
    compareProduct: "_ec_",
    countryType: "export",
    manyCountryType: "exports",
    countryTypeCode: "E",
    redirectionID: "ec_exports",
    analyticsCountryID: "ECUADOR-EXPORTS",
    localProduct: "intel-ecuador",
    countryUrlDashboard: "country=ecuador",
    countryPathName: "ecuador-search-export",
    countryName: "Ecuador Exports",
    continent: "CSA",
    dataSource: "ecuador exports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search using Consignee’s name", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search using Shipper’s name or RUC number", pillColor: "#07710b" },

      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search using Harmonised System Codes such as 0805: Citrus fruit, fresh or dried", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
      { value: searchPhraseDictionary.ports, label: "Ports", placeHolder: "Search upto 20 Ports’s name", pillColor: "#de1368" },
    ],
  },
  ar_import: {
    // Argentina Import
    country_small: "argentina",
    country_caps: "ARGENTINA",
    product_id: "trademo_AR",
    country_CamelCase: "Argentina",
    countryCode: "AR",
    countryCodeFlag: "AR",
    compareProduct: "_ar_",
    countryType: "import",
    manyCountryType: "imports",
    countryTypeCode: "I",
    redirectionID: "ar_imports",
    analyticsCountryID: "ARGENTINA-IMPORTS",
    localProduct: "intel-argentina",
    countryUrlDashboard: "country=argentina",
    countryPathName: "argentina-search-import",
    countryName: "Argentina Imports",
    isMonthPicker: true,
    continent: "CSA",
    dataSource: "argentina imports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name", pillColor: "#2a3791" },

      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.ports, label: "Ports", placeHolder: "Search upto 20 Ports’s name", pillColor: "#de1368" },
    ],
  },
  ar_export: {
    // Argentina Export
    country_small: "argentina",
    country_caps: "ARGENTINA",
    product_id: "trademo_AR",
    country_CamelCase: "Argentina",
    countryCode: "AR",
    countryCodeFlag: "AR",
    compareProduct: "_ar_",
    countryType: "export",
    manyCountryType: "exports",
    countryTypeCode: "E",
    redirectionID: "ar_exports",
    analyticsCountryID: "ARGENTINA-EXPORTS",
    localProduct: "intel-argentina",
    countryUrlDashboard: "country=argentina",
    countryPathName: "argentina-search-export",
    countryName: "Argentina Exports",
    continent: "CSA",
    dataSource: "argentina exports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },

      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product Description", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e3730c" },
      { value: searchPhraseDictionary.ports, label: "Ports", placeHolder: "Search upto 20 Ports’s name", pillColor: "#de1368" },
    ],
  },
  pe_import: {
    // Peru Import
    country_small: "peru",
    country_caps: "PERU",
    product_id: "trademo_PR",
    country_CamelCase: "Peru",
    countryCode: "PR",
    countryCodeFlag: "PE",
    compareProduct: "_pr_",
    countryType: "import",
    manyCountryType: "imports",
    countryTypeCode: "I",
    redirectionID: "pr_imports",
    analyticsCountryID: "PERU-IMPORTS",
    localProduct: "intel-peru",
    countryUrlDashboard: "country=peru",
    countryPathName: "peru-search-import",
    countryName: "Peru Imports",
    continent: "CSA",
    dataSource: "peru imports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },

      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
      { value: searchPhraseDictionary.ports, label: "Ports", placeHolder: "Search upto 20 Ports’s name", pillColor: "#de1368" },
    ],
  },
  pe_export: {
    // Peru Export
    country_small: "peru",
    country_caps: "PERU",
    product_id: "trademo_PR",
    country_CamelCase: "Peru",
    countryCode: "PR",
    countryCodeFlag: "PE",
    compareProduct: "_pr_",
    countryType: "export",
    manyCountryType: "exports",
    countryTypeCode: "E",
    redirectionID: "pr_exports",
    analyticsCountryID: "PERU-EXPORTS",
    localProduct: "intel-peru",
    countryUrlDashboard: "country=peru",
    countryPathName: "peru-search-export",
    countryName: "Peru Exports",
    continent: "CSA",
    dataSource: "peru exports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name", pillColor: "#07710b" },

      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.ports, label: "Ports", placeHolder: "Search upto 20 Ports’s name", pillColor: "#de1368" },
    ],
  },
  mx_import: {
    // Mexico Import
    country_small: "mexico",
    country_caps: "MEXICO",
    product_id: "trademo_MX",
    country_CamelCase: "Mexico",
    countryCode: "MX",
    countryCodeFlag: "MX",
    compareProduct: "_mx_",
    countryType: "import",
    manyCountryType: "imports",
    countryTypeCode: "I",
    redirectionID: "mx_imports",
    analyticsCountryID: "MEXICO-IMPORTS",
    localProduct: "intel-mexico",
    countryUrlDashboard: "country=mexico",
    countryPathName: "mexico-search-import",
    countryName: "Mexico Imports",
    continent: "NA",
    dataSource: "mexico imports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee's name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },

      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
      { value: searchPhraseDictionary.ports, label: "Ports", placeHolder: "Search upto 20 Ports’s name", pillColor: "#de1368" },
    ],
  },
  mx_export: {
    // Mexico Export
    country_small: "mexico",
    country_caps: "MEXICO",
    product_id: "trademo_MX",
    country_CamelCase: "Mexico",
    countryCode: "MX",
    countryCodeFlag: "MX",
    compareProduct: "_mx_",
    countryType: "export",
    manyCountryType: "exports",
    countryTypeCode: "E",
    redirectionID: "mx_exports",
    analyticsCountryID: "MEXICO-EXPORTS",
    localProduct: "intel-mexico",
    countryUrlDashboard: "country=mexico",
    countryPathName: "mexico-search-export",
    countryName: "Mexico Exports",
    continent: "NA",
    dataSource: "mexico exports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search using Consignee’s name", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search using Shipper’s name or RUC number", pillColor: "#07710b" },

      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search using Harmonised System Codes such as 0805: Citrus fruit, fresh or dried", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
      { value: searchPhraseDictionary.ports, label: "Ports", placeHolder: "Search upto 20 Ports’s name", pillColor: "#de1368" },
    ],
  },
  br_import: {
    // Brazil Import
    country_small: "brazil",
    country_caps: "BRAZIL",
    product_id: "trademo_BR",
    country_CamelCase: "Brazil",
    countryCode: "BR",
    countryCodeFlag: "BR",
    compareProduct: "_br_",
    countryType: "import",
    manyCountryType: "imports",
    countryTypeCode: "I",
    redirectionID: "br_imports",
    analyticsCountryID: "BRAZIL-IMPORTS",
    localProduct: "intel-brazil",
    countryUrlDashboard: "country=brazil",
    countryPathName: "brazil-search-import-mirror",
    countryName: "Brazil Imports (Mirror)",
    continent: "MIRROR",
    dataSource: "brazil imports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search using Consignee’s name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search using Shipper’s name or address", pillColor: "#07710b" },
      { value: searchPhraseDictionary.logistics, label: "Logistics", placeHolder: "Search upto 20 Logistics by name or SCAC", pillColor: "#178add" },

      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search using Harmonised System Codes such as 0805: Citrus fruit, fresh or dried", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search for chemicals.", pillColor: "#e3730c" },
      { value: searchPhraseDictionary.ports, label: "Ports", placeHolder: "Search upto 20 Ports’s name", pillColor: "#de1368" },
    ],
  },
  br_export: {
    // Brazil Export
    country_small: "brazil",
    country_caps: "BRAZIL",
    product_id: "trademo_BR",
    country_CamelCase: "Brazil",
    countryCode: "BR",
    countryCodeFlag: "BR",
    compareProduct: "_br_",
    countryType: "export",
    manyCountryType: "exports",
    countryTypeCode: "E",
    redirectionID: "br_exports",
    analyticsCountryID: "BRAZIL-EXPORTS",
    localProduct: "intel-brazil",
    countryUrlDashboard: "country=brazil",
    countryPathName: "brazil-search-export-mirror",
    countryName: "Brazil Exports (Mirror)",
    continent: "MIRROR",
    dataSource: "brazil exports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search using Consignee’s name", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search using Shipper’s name or RUC number", pillColor: "#07710b" },
      { value: searchPhraseDictionary.logistics, label: "Logistics", placeHolder: "Search upto 20 Logistics by name or SCAC", pillColor: "#178add" },

      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search using Harmonised System Codes such as 0805: Citrus fruit, fresh or dried", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search for Chemicals.", pillColor: "#e3730c" },
      { value: searchPhraseDictionary.ports, label: "Ports", placeHolder: "Search upto 20 Ports’s name", pillColor: "#de1368" },
    ],
  },
  id_export: {
    // indonesia Export
    country_small: "indonesia",
    country_caps: "INDONESIA",
    product_id: "trademo_ID",
    country_CamelCase: "Indonesia",
    countryCode: "ID",
    countryCodeFlag: "ID",
    compareProduct: "_sas_",
    countryType: "export",
    manyCountryType: "exports",
    countryTypeCode: "E",
    redirectionID: "id_exports",
    analyticsCountryID: "INDONESIA-EXPORTS",
    localProduct: "intel-indonesia",
    countryUrlDashboard: "country=indonesia",
    countryPathName: "indonesia-search-export-mirror",
    countryName: "Indonesia Exports (Mirror)",
    continent: "MIRROR",
    dataSource: "indonesia exports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },

      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
      { value: searchPhraseDictionary.ports, label: "Ports", placeHolder: "Search upto 20 Ports’s name", pillColor: "#de1368" },
    ],
  },
  id_import: {
    // indonesia Import
    country_small: "indonesia",
    country_caps: "INDONESIA",
    product_id: "trademo_ID",
    country_CamelCase: "Indonesia",
    countryCode: "ID",
    countryCodeFlag: "ID",
    compareProduct: "_sas_",
    countryType: "import",
    manyCountryType: "imports",
    countryTypeCode: "I",
    redirectionID: "id_imports",
    analyticsCountryID: "INDONESIA-IMPORTS",
    localProduct: "intel-indonesia",
    countryUrlDashboard: "country=indonesia",
    countryPathName: "indonesia-search-import-mirror",
    countryName: "Indonesia Imports (Mirror)",
    continent: "MIRROR",
    dataSource: "indonesia imports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },

      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
      { value: searchPhraseDictionary.ports, label: "Ports", placeHolder: "Search upto 20 Ports’s name", pillColor: "#de1368" },
    ],
  },
  idnm_export: {
    // indonesia Export (NM)
    country_small: "indonesia nm",
    country_caps: "INDONESIA NM",
    product_id: "trademo_IDNM",
    country_CamelCase: "Indonesia",
    countryCode: "IDNM",
    countryCodeFlag: "IDNM",
    compareProduct: "_idnm_",
    countryType: "export",
    manyCountryType: "exports",
    countryTypeCode: "E",
    redirectionID: "idnm_exports",
    analyticsCountryID: "INDONESIA-NM-EXPORTS",
    localProduct: "intel-indonesia",
    countryUrlDashboard: "country=indonesia-nm",
    countryPathName: "indonesia-search-export-nm",
    countryName: "Indonesia Exports",
    continent: "ASIA",
    dataSource: "indonesia nm exports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },
      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      // { value: searchPhraseDictionary.ports, label: "Ports", placeHolder: "Search upto 20 Ports’s name", pillColor: "#de1368" },
    ],
  },
  idnm_import: {
    // indonesia Import (NM)
    country_small: "indonesia nm",
    country_caps: "INDONESIA NM",
    product_id: "trademo_IDNM",
    country_CamelCase: "Indonesia",
    countryCode: "IDNM",
    countryCodeFlag: "IDNM",
    compareProduct: "_idnm_",
    countryType: "import",
    manyCountryType: "imports",
    countryTypeCode: "I",
    redirectionID: "idnm_imports",
    analyticsCountryID: "INDONESIA-NM-IMPORTS",
    localProduct: "intel-indonesia",
    countryUrlDashboard: "country=indonesia-nm",
    countryPathName: "indonesia-search-import-nm",
    countryName: "Indonesia Imports",
    continent: "ASIA",
    dataSource: "indonesia nm imports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },
      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      // { value: searchPhraseDictionary.ports, label: "Ports", placeHolder: "Search upto 20 Ports’s name", pillColor: "#de1368" },
    ],
  },
  multi_country: {
    // multi countries all data
    country_small: "multicountry",
    country_caps: "MULTICOUNTRY",
    product_id: "trademo_MC",
    country_CamelCase: "Multicountry",
    countryCode: "world",
    countryCodeImage: "https://res.cloudinary.com/drzta9shk/image/upload/v1681887388/intel/icons/alldata_icon_ednqbi.svg",
    compareProduct: "_multi_",
    countryType: "import",
    manyCountryType: "imports",
    countryTypeCode: "I",
    redirectionID: "mc_imports",
    analyticsCountryID: "MULTICOUNTRY-IMPORTS",
    localProduct: "intel-all-data",
    countryUrlDashboard: "country=multicountry",
    countryPathName: "all-country-shipments",
    countryName: "Universal Search",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },
      { value: searchPhraseDictionary.logistics, label: "Logistics", placeHolder: "Search upto 20 Logistics by name or SCAC", pillColor: "#178add" },

      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
      { value: searchPhraseDictionary.ports, label: "Ports", placeHolder: "Search upto 20 Ports’s name", pillColor: "#de1368" },
    ],
  },
  ph_export: {
    // philippines Export
    country_small: "philippines",
    country_caps: "PHILIPPINES",
    product_id: "trademo_PH",
    country_CamelCase: "Philippines",
    countryCode: "PH",
    countryCodeFlag: "PH",
    compareProduct: "_ph_",
    countryType: "export",
    manyCountryType: "exports",
    countryTypeCode: "E",
    redirectionID: "ph_exports",
    analyticsCountryID: "PHILIPPINES-EXPORTS",
    localProduct: "intel-philippines",
    countryUrlDashboard: "country=philippines",
    countryPathName: "philippines-search-export",
    countryName: "Philippines Exports",
    continent: "ASIA",
    dataSource: "philippines exports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee's name or address", pillColor: "#2a3791" },
    ],
  },
  ph_import: {
    // philippines Import
    country_small: "philippines",
    country_caps: "PHILIPPINES",
    product_id: "trademo_PH",
    country_CamelCase: "Philippines",
    countryCode: "PH",
    countryCodeFlag: "PH",
    compareProduct: "_ph_",
    countryType: "import",
    manyCountryType: "imports",
    countryTypeCode: "I",
    redirectionID: "ph_imports",
    analyticsCountryID: "PHILIPPINES-IMPORTS",
    localProduct: "intel-philippines",
    countryUrlDashboard: "country=philippines",
    countryPathName: "philippines-search-import",
    countryName: "Philippines Imports",
    continent: "ASIA",
    dataSource: "philippines imports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee's name or address", pillColor: "#2a3791" },
    ],
  },
  vn_export: {
    // vietnam Export
    country_small: "vietnam",
    country_caps: "VIETNAM",
    product_id: "trademo_VN",
    country_CamelCase: "Vietnam",
    countryCode: "VN",
    countryCodeFlag: "VN",
    compareProduct: "_vn_",
    countryType: "export",
    manyCountryType: "exports",
    countryTypeCode: "E",
    redirectionID: "vn_exports",
    analyticsCountryID: "VIETNAM-EXPORTS",
    localProduct: "intel-vietnam",
    countryUrlDashboard: "country=vietnam",
    countryPathName: "vietnam-search-export",
    countryName: "Vietnam Exports",
    continent: "ASIA",
    dataSource: "vietnam exports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search using Harmonised System Codes such as 0805: Citrus fruit, fresh or dried", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search using Shipper’s name or RUC number", pillColor: "#07710b" },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search using Consignee’s name", pillColor: "#2a3791" },
    ],
  },
  vn_import: {
    // vietnam Import
    country_small: "vietnam",
    country_caps: "VIETNAM",
    product_id: "trademo_VN",
    country_CamelCase: "Vietnam",
    countryCode: "VN",
    countryCodeFlag: "VN",
    compareProduct: "_vn_",
    countryType: "import",
    manyCountryType: "imports",
    countryTypeCode: "I",
    redirectionID: "vn_imports",
    analyticsCountryID: "VIETNAM-IMPORTS",
    localProduct: "intel-vietnam",
    countryUrlDashboard: "country=vietnam",
    countryPathName: "vietnam-search-import",
    countryName: "Vietnam Imports",
    continent: "ASIA",
    dataSource: "vietnam imports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee's name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },

      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
    ],
  },
  inmr3_export: {
    // india Export
    country_small: "india mirror 3",
    country_caps: "INDIA MIRROR 3",
    product_id: "trademo_INMR3",
    country_CamelCase: "India",
    countryCode: "INMR3",
    countryCodeFlag: "INMR3",
    compareProduct: "_in_",
    countryType: "export",
    manyCountryType: "exports",
    countryTypeCode: "E",
    redirectionID: "inmr3_exports",
    analyticsCountryID: "INDIA-EXPORTS",
    localProduct: "intel-india",
    countryUrlDashboard: "country=india mirror 3",
    countryPathName: "india-search-export",
    countryName: "India Exports (Mirror 1)",
    continent: "MIRROR",
    dataSource: "india mirror 3 exports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee's name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },

      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
      { value: searchPhraseDictionary.ports, label: "Ports", placeHolder: "Search upto 20 Ports’s name", pillColor: "#de1368" },
    ],
  },
  inmr3_import: {
    // india Import
    country_small: "india mirror 3",
    country_caps: "INDIA MIRROR 3",
    product_id: "trademo_INMR3",
    country_CamelCase: "India",
    countryCode: "INMR3",
    countryCodeFlag: "INMR3",
    compareProduct: "_in_",
    countryType: "import",
    manyCountryType: "imports",
    countryTypeCode: "I",
    redirectionID: "inmr3_imports",
    analyticsCountryID: "INDIA-IMPORTS",
    localProduct: "intel-india",
    countryUrlDashboard: "country=india mirror 3",
    countryPathName: "india-search-import",
    countryName: "India Imports (Mirror 1)",
    continent: "MIRROR",
    dataSource: "india mirror 3 imports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee's name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },

      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
      { value: searchPhraseDictionary.ports, label: "Ports", placeHolder: "Search upto 20 Ports’s name", pillColor: "#de1368" },
    ],
  },
  inmr_import: {
    // India Import (Mirror)
    country_small: "india mirror",
    country_caps: "INDIA MIRROR",
    product_id: "trademo_INMR",
    country_CamelCase: "India",
    countryCode: "INMR",
    countryCodeFlag: "INMR",
    compareProduct: "_inmr_",
    countryType: "import",
    manyCountryType: "imports",
    countryTypeCode: "I",
    redirectionID: "inmr_imports",
    analyticsCountryID: "INDIA-MIRROR-IMPORTS",
    localProduct: "intel-india",
    countryUrlDashboard: "country=india mirror",
    countryPathName: "india-search-import-mirror",
    countryName: "India Imports (Mirror)",
    continent: "MIRROR",
    dataSource: "india mirror imports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee's name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },
      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
      { value: searchPhraseDictionary.ports, label: "Ports", placeHolder: "Search upto 20 Ports’s name", pillColor: "#de1368" },
    ],
  },
  inmr_export: {
    // India Export (Mirror)
    country_small: "india mirror",
    country_caps: "INDIA MIRROR",
    product_id: "trademo_INMR",
    country_CamelCase: "India",
    countryCode: "INMR",
    countryCodeFlag: "INMR",
    compareProduct: "_inmr_",
    countryType: "export",
    manyCountryType: "exports",
    countryTypeCode: "E",
    redirectionID: "inmr_exports",
    analyticsCountryID: "INDIA-MIRROR-EXPORTS",
    localProduct: "intel-india",
    countryUrlDashboard: "country=india mirror",
    countryPathName: "india-search-export-mirror",
    countryName: "India Exports (Mirror)",
    continent: "MIRROR",
    dataSource: "india mirror exports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee's name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },
      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
      { value: searchPhraseDictionary.ports, label: "Ports", placeHolder: "Search upto 20 Ports’s name", pillColor: "#de1368" },
    ],
  },
  ru_import: {
    // Russia Import
    country_small: "russia",
    country_caps: "RUSSIA",
    product_id: "trademo_RU",
    country_CamelCase: "Russia",
    countryCode: "RU",
    countryCodeFlag: "RU",
    compareProduct: "_ru_",
    countryType: "import",
    manyCountryType: "imports",
    countryTypeCode: "I",
    redirectionID: "ru_imports",
    analyticsCountryID: "RUSSIA-IMPORTS",
    localProduct: "intel-russia",
    countryUrlDashboard: "country=russia",
    countryPathName: "russia-search-import-mirror",
    countryName: "Russia Imports (Mirror)",
    continent: "MIRROR",
    dataSource: "russia imports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },
      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
      // { value: searchPhraseDictionary.ports, label: "Ports", placeHolder: "Search upto 20 Ports’s name", pillColor: "#de1368" },
    ],
  },
  ru_export: {
    // Russia Export
    country_small: "russia",
    country_caps: "RUSSIA",
    product_id: "trademo_RU",
    country_CamelCase: "Russia",
    countryCode: "RU",
    countryCodeFlag: "RU",
    compareProduct: "_ru_",
    countryType: "export",
    manyCountryType: "exports",
    countryTypeCode: "E",
    redirectionID: "ru_exports",
    analyticsCountryID: "RUSSIA-EXPORTS",
    localProduct: "intel-russia",
    countryUrlDashboard: "country=russia",
    countryPathName: "russia-search-export-mirror",
    countryName: "Russia Exports (Mirror)",
    continent: "MIRROR",
    dataSource: "russia exports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },
      { value: searchPhraseDictionary.ports, label: "Ports", placeHolder: "Search upto 20 Ports’s name", pillColor: "#de1368" },
      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
    ],
  },
  runm_import: {
    // Russia Import (NM)
    country_small: "russia nm",
    country_caps: "RUSSIA NM",
    product_id: "trademo_RUNM",
    country_CamelCase: "Russia",
    countryCode: "RUNM",
    countryCodeFlag: "RUNM",
    compareProduct: "_runm_",
    countryType: "import",
    manyCountryType: "imports",
    countryTypeCode: "I",
    redirectionID: "runm_imports",
    analyticsCountryID: "RUSSIA-NM-IMPORTS",
    localProduct: "intel-russia",
    countryUrlDashboard: "country=russia-nm",
    countryPathName: "russia-search-import",
    countryName: "Russia Imports",
    continent: "ASIA",
    dataSource: "russia nm imports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },
      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
      // { value: searchPhraseDictionary.ports, label: "Ports", placeHolder: "Search upto 20 Ports’s name", pillColor: "#de1368" },
    ],
  },
  runm_export: {
    // Russia Export (NM)
    country_small: "russia nm",
    country_caps: "RUSSIA NM",
    product_id: "trademo_RUNM",
    country_CamelCase: "Russia",
    countryCode: "RUNM",
    countryCodeFlag: "RUNM",
    compareProduct: "_runm_",
    countryType: "export",
    manyCountryType: "exports",
    countryTypeCode: "E",
    redirectionID: "runm_exports",
    analyticsCountryID: "RUSSIA-NM-EXPORTS",
    localProduct: "intel-russia",
    countryUrlDashboard: "country=russia-nm",
    countryPathName: "russia-search-export",
    countryName: "Russia Exports",
    continent: "ASIA",
    dataSource: "russia nm exports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },
      // { value: searchPhraseDictionary.ports, label: "Ports", placeHolder: "Search upto 20 Ports’s name", pillColor: "#de1368" },
      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
    ],
  },
  cn_import: {
    country_small: "china",
    country_caps: "CHINA",
    product_id: "trademo_CN",
    country_CamelCase: "China",
    countryCode: "CN",
    countryCodeFlag: "CN",
    compareProduct: "_cn_",
    countryType: "import",
    manyCountryType: "imports",
    countryTypeCode: "I",
    redirectionID: "cn_imports",
    analyticsCountryID: "CHINA-IMPORTS",
    localProduct: "intel-china",
    countryUrlDashboard: "country=china",
    countryPathName: "china-search-import-mirror",
    countryName: "China Imports (Mirror)",
    continent: "MIRROR",
    dataSource: "china imports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },
      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
      { value: searchPhraseDictionary.ports, label: "Ports", placeHolder: "Search upto 20 Ports’s name", pillColor: "#de1368" },
    ],
  },
  cn_export: {
    country_small: "china",
    country_caps: "CHINA",
    product_id: "trademo_CN",
    country_CamelCase: "China",
    countryCode: "CN",
    countryCodeFlag: "CN",
    compareProduct: "_cn_",
    countryType: "export",
    manyCountryType: "exports",
    countryTypeCode: "E",
    redirectionID: "cn_exports",
    analyticsCountryID: "CHINA-EXPORTS",
    localProduct: "intel-china",
    countryUrlDashboard: "country=china",
    countryPathName: "china-search-export-mirror",
    countryName: "China Exports (Mirror)",
    continent: "MIRROR",
    dataSource: "china exports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },
      { value: searchPhraseDictionary.ports, label: "Ports", placeHolder: "Search upto 20 Ports’s name", pillColor: "#de1368" },
      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
    ],
  },

  global_plan: {
    // multi countries all data
    country_small: "global data",
    country_caps: "GLOBAL DATA",
    product_id: "trademo_GLOBAL",
    country_CamelCase: "Global Data",
    countryCode: "global",
    countryCodeImage: "https://res.cloudinary.com/drzta9shk/image/upload/v1681887388/intel/icons/alldata_icon_ednqbi.svg",
    compareProduct: "_multi_",
    countryType: "import",
    manyCountryType: "imports",
    countryTypeCode: "I",
    redirectionID: "global_imports",
    analyticsCountryID: "GLOBAL-IMPORTS",
    localProduct: "intel-global-data",
    countryUrlDashboard: "country=global data",
    countryPathName: "global-search",
    countryName: "Global",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },
      { value: searchPhraseDictionary.logistics, label: "Logistics", placeHolder: "Search upto 20 Logistics by name or SCAC", pillColor: "#178add" },
      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
      { value: searchPhraseDictionary.ports, label: "Ports", placeHolder: "Search upto 20 Ports’s name", pillColor: "#de1368" },
    ],
  },
  bd_export: {
    country_small: "bangladesh",
    country_caps: "BANGLADESH",
    product_id: "trademo_BD",
    country_CamelCase: "Bangladesh",
    countryCode: "BD",
    countryCodeFlag: "BD",
    compareProduct: "_bd_",
    countryType: "export",
    manyCountryType: "exports",
    countryTypeCode: "E",
    redirectionID: "bd_exports",
    analyticsCountryID: "BANGLADESH-EXPORTS",
    localProduct: "intel-bangladesh",
    countryUrlDashboard: "country=bangladesh",
    countryPathName: "bangladesh-search-export",
    countryName: "Bangladesh Exports",
    continent: "ASIA",
    dataSource: "bangladesh exports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },

      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
    ],
  },
  bd_import: {
    country_small: "bangladesh",
    country_caps: "BANGLADESH",
    product_id: "trademo_BD",
    country_CamelCase: "Bangladesh",
    countryCode: "BD",
    countryCodeFlag: "BD",
    compareProduct: "_bd_",
    countryType: "import",
    manyCountryType: "imports",
    countryTypeCode: "I",
    redirectionID: "bd_imports",
    analyticsCountryID: "BANGLADESH-IMPORTS",
    localProduct: "intel-bangladesh",
    countryUrlDashboard: "country=bangladesh",
    countryPathName: "bangladesh-search-import",
    countryName: "Bangladesh Imports",
    continent: "ASIA",
    dataSource: "bangladesh imports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },

      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
    ],
  },
  gh_import: {
    country_small: "ghana",
    country_caps: "GHANA",
    product_id: "trademo_GH",
    country_CamelCase: "Ghana",
    countryCode: "GH",
    countryCodeFlag: "GH",
    compareProduct: "_gh_",
    countryType: "import",
    manyCountryType: "imports",
    countryTypeCode: "I",
    redirectionID: "gh_imports",
    analyticsCountryID: "GHANA-IMPORTS",
    localProduct: "intel-ghana",
    countryUrlDashboard: "country=ghana",
    countryPathName: "ghana-search-import",
    countryName: "Ghana Imports",
    continent: "AFRICA",
    dataSource: "ghana imports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },
      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
    ],
  },
  na_import: {
    country_small: "namibia",
    country_caps: "NAMIBIA",
    product_id: "trademo_NA",
    country_CamelCase: "Namibia",
    countryCode: "NA",
    countryCodeFlag: "NA",
    compareProduct: "_na_",
    countryType: "import",
    manyCountryType: "imports",
    countryTypeCode: "I",
    redirectionID: "na_imports",
    analyticsCountryID: "NAMIBIA-IMPORTS",
    localProduct: "intel-namibia",
    countryUrlDashboard: "country=namibia",
    countryPathName: "namibia-search-import",
    countryName: "Namibia Imports",
    continent: "AFRICA",
    dataSource: "namibia imports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },
      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
    ],
  },
  na_export: {
    country_small: "namibia",
    country_caps: "NAMIBIA",
    product_id: "trademo_NA",
    country_CamelCase: "Namibia",
    countryCode: "NA",
    countryCodeFlag: "NA",
    compareProduct: "_na_",
    countryType: "export",
    manyCountryType: "exports",
    countryTypeCode: "E",
    redirectionID: "na_exports",
    analyticsCountryID: "NAMIBIA-EXPORTS",
    localProduct: "intel-namibia",
    countryUrlDashboard: "country=namibia",
    countryPathName: "namibia-search-export",
    countryName: "Namibia Exports",
    continent: "AFRICA",
    dataSource: "namibia exports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },
      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
    ],
  },
  rw_import: {
    country_small: "rwanda",
    country_caps: "RWANDA",
    product_id: "trademo_RW",
    country_CamelCase: "Rwanda",
    countryCode: "RW",
    countryCodeFlag: "RW",
    compareProduct: "_rw_",
    countryType: "import",
    manyCountryType: "imports",
    countryTypeCode: "I",
    redirectionID: "rw_imports",
    analyticsCountryID: "RWANDA-IMPORTS",
    localProduct: "intel-rwanda",
    countryUrlDashboard: "country=rwanda",
    countryPathName: "rwanda-search-import",
    countryName: "Rwanda Imports",
    continent: "AFRICA",
    dataSource: "rwanda imports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },

      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
    ],
  },
  ls_export: {
    country_small: "lesotho",
    country_caps: "LESOTHO",
    product_id: "trademo_LS",
    country_CamelCase: "Lesotho",
    countryCode: "LS",
    countryCodeFlag: "LS",
    compareProduct: "_ls_",
    countryType: "export",
    manyCountryType: "exports",
    countryTypeCode: "E",
    redirectionID: "ls_exports",
    analyticsCountryID: "LESOTHO-EXPORTS",
    localProduct: "intel-lesotho",
    countryUrlDashboard: "country=lesotho",
    countryPathName: "lesotho-search-export",
    countryName: "Lesotho Exports",
    continent: "AFRICA",
    dataSource: "lesotho exports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },

      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
    ],
  },
  ls_import: {
    country_small: "lesotho",
    country_caps: "LESOTHO",
    product_id: "trademo_LS",
    country_CamelCase: "Lesotho",
    countryCode: "LS",
    countryCodeFlag: "LS",
    compareProduct: "_ls_",
    countryType: "import",
    manyCountryType: "imports",
    countryTypeCode: "I",
    redirectionID: "ls_imports",
    analyticsCountryID: "LESOTHO-IMPORTS",
    localProduct: "intel-lesotho",
    countryUrlDashboard: "country=lesotho",
    countryPathName: "lesotho-search-import",
    countryName: "Lesotho Imports",
    continent: "AFRICA",
    dataSource: "lesotho imports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },

      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
    ],
  },
  kz_import: {
    country_small: "kazakhstan",
    country_caps: "KAZAKHSTAN",
    product_id: "trademo_KZ",
    country_CamelCase: "Kazakhstan",
    countryCode: "KZ",
    countryCodeFlag: "KZ",
    compareProduct: "_kz_",
    countryType: "import",
    manyCountryType: "imports",
    countryTypeCode: "I",
    redirectionID: "kz_imports",
    analyticsCountryID: "KAZAKHSTAN-IMPORTS",
    localProduct: "intel-kazakhstan",
    countryUrlDashboard: "country=kazakhstan",
    countryPathName: "kazakhstan-search-import",
    countryName: "Kazakhstan Imports",
    continent: "ASIA",
    dataSource: "kazakhstan imports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },
      //
      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
    ],
  },
  kz_export: {
    country_small: "kazakhstan",
    country_caps: "KAZAKHSTAN",
    product_id: "trademo_KZ",
    country_CamelCase: "Kazakhstan",
    countryCode: "KZ",
    countryCodeFlag: "KZ",
    compareProduct: "_kz_",
    countryType: "export",
    manyCountryType: "exports",
    countryTypeCode: "E",
    redirectionID: "kz_exports",
    analyticsCountryID: "KAZAKHSTAN-EXPORTS",
    localProduct: "intel-kazakhstan",
    countryUrlDashboard: "country=kazakhstan",
    countryPathName: "kazakhstan-search-export",
    countryName: "Kazakhstan Exports",
    continent: "ASIA",
    dataSource: "kazakhstan exports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },
      //
      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
    ],
  },
  ng_import: {
    country_small: "nigeria",
    country_caps: "NIGERIA",
    product_id: "trademo_NG",
    country_CamelCase: "Nigeria",
    countryCode: "NG",
    countryCodeFlag: "NG",
    compareProduct: "_ng_",
    countryType: "import",
    manyCountryType: "imports",
    countryTypeCode: "I",
    redirectionID: "ng_imports",
    analyticsCountryID: "NIGERIA-IMPORTS",
    localProduct: "intel-nigeria",
    countryUrlDashboard: "country=nigeria",
    countryPathName: "nigeria-search-import",
    countryName: "Nigeria Imports",
    continent: "AFRICA",
    dataSource: "nigeria imports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },
      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
    ],
  },
  pk_import: {
    country_small: "pakistan",
    country_caps: "PAKISTAN",
    product_id: "trademo_PK",
    country_CamelCase: "Pakistan",
    countryCode: "PK",
    countryCodeFlag: "PK",
    compareProduct: "_pk_",
    countryType: "import",
    manyCountryType: "imports",
    countryTypeCode: "I",
    redirectionID: "pk_imports",
    analyticsCountryID: "PAKISTAN-IMPORTS",
    localProduct: "intel-pakistan",
    countryUrlDashboard: "country=pakistan",
    countryPathName: "pakistan-search-import",
    countryName: "Pakistan Imports",
    continent: "ASIA",
    dataSource: "pakistan imports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },
      //
      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
    ],
  },
  pk_export: {
    country_small: "pakistan",
    country_caps: "PAKISTAN",
    product_id: "trademo_PK",
    country_CamelCase: "Pakistan",
    countryCode: "PK",
    countryCodeFlag: "PK",
    compareProduct: "_pk_",
    countryType: "export",
    manyCountryType: "exports",
    countryTypeCode: "E",
    redirectionID: "pk_exports",
    analyticsCountryID: "PAKISTAN-EXPORTS",
    localProduct: "intel-pakistan",
    countryUrlDashboard: "country=pakistan",
    countryPathName: "pakistan-search-export",
    countryName: "Pakistan Exports",
    continent: "ASIA",
    dataSource: "pakistan exports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },
      //
      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
    ],
  },
  cm_import: {
    country_small: "cameroon",
    country_caps: "CAMEROON",
    product_id: "trademo_CM",
    country_CamelCase: "Cameroon",
    countryCode: "CM",
    countryCodeFlag: "CM",
    compareProduct: "_cm_",
    countryType: "import",
    manyCountryType: "imports",
    countryTypeCode: "I",
    redirectionID: "cm_imports",
    analyticsCountryID: "CAMEROON-IMPORTS",
    localProduct: "intel-cameroon",
    countryUrlDashboard: "country=cameroon",
    countryPathName: "cameroon-search-import",
    countryName: "Cameroon Imports",
    continent: "AFRICA",
    dataSource: "cameroon imports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },

      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
    ],
  },
  // cm_export: {
  //   country_small: "cameroon",
  //   country_caps: "CAMEROON",
  //   product_id: "trademo_CM",
  //   country_CamelCase: "Cameroon",
  //   countryCode: "CM",
  //   countryCodeFlag: "CM",
  //   compareProduct: "_cm_",
  //   countryType: "export",
  //   manyCountryType: "exports",
  //   countryTypeCode: "E",
  //   redirectionID: "cm_exports",
  //   analyticsCountryID: "CAMEROON-EXPORTS",
  //   localProduct: "intel-cameroon",
  //   countryUrlDashboard: "country=cameroon",
  //   countryPathName: "cameroon-search-export",
  //   countryName: "Cameroon Exports",
  //   plansDictionary: upgradeRussiaPlansDictionary,
  //   continent: "AFRICA",
  //   dataSource: "cameroon exports",
  //   defaultDropDown: [
  //     {
  //       value: searchPhraseDictionary.entire_bill_of_lading,
  //       label: "All Categories",
  //       placeHolder: "Type to search in all categories or choose from the category below",
  //     },
  //     { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },
  //     { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },
  //
  //     { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
  //     { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
  //     { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
  //   ],
  // },
  ng_export: {
    country_small: "nigeria",
    country_caps: "NIGERIA",
    product_id: "trademo_NG",
    country_CamelCase: "Nigeria",
    countryCode: "NG",
    countryCodeFlag: "NG",
    compareProduct: "_ng_",
    countryType: "export",
    manyCountryType: "exports",
    countryTypeCode: "E",
    redirectionID: "ng_exports",
    analyticsCountryID: "NIGERIA-EXPORTS",
    localProduct: "intel-nigeria",
    countryUrlDashboard: "country=nigeria",
    countryPathName: "nigeria-search-export",
    countryName: "Nigeria Exports",
    continent: "AFRICA",
    dataSource: "nigeria exports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      // { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },
      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
    ],
  },
  gh_export: {
    country_small: "ghana",
    country_caps: "GHANA",
    product_id: "trademo_GH",
    country_CamelCase: "Ghana",
    countryCode: "GH",
    countryCodeFlag: "GH",
    compareProduct: "_gh_",
    countryType: "export",
    manyCountryType: "exports",
    countryTypeCode: "E",
    redirectionID: "gh_exports",
    analyticsCountryID: "GHANA-EXPORTS",
    localProduct: "intel-ghana",
    countryUrlDashboard: "country=ghana",
    countryPathName: "ghana-search-export",
    countryName: "Ghana Exports",
    continent: "AFRICA",
    dataSource: "ghana exports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },

      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
    ],
  },
  bw_import: {
    country_small: "botswana",
    country_caps: "BOTSWANA",
    product_id: "trademo_BW",
    country_CamelCase: "Botswana",
    countryCode: "BW",
    countryCodeFlag: "BW",
    compareProduct: "_bw_",
    countryType: "import",
    manyCountryType: "imports",
    countryTypeCode: "I",
    redirectionID: "bw_imports",
    analyticsCountryID: "BOTSWANA-IMPORTS",
    localProduct: "intel-botswana",
    countryUrlDashboard: "country=botswana",
    countryPathName: "botswana-search-import",
    countryName: "Botswana Imports",
    continent: "AFRICA",
    dataSource: "botswana imports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },
      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
    ],
  },
  bw_export: {
    country_small: "botswana",
    country_caps: "BOTSWANA",
    product_id: "trademo_BW",
    country_CamelCase: "Botswana",
    countryCode: "BW",
    countryCodeFlag: "BW",
    compareProduct: "_bw_",
    countryType: "export",
    manyCountryType: "exports",
    countryTypeCode: "E",
    redirectionID: "bw_exports",
    analyticsCountryID: "BOTSWANA-EXPORTS",
    localProduct: "intel-botswana",
    countryUrlDashboard: "country=botswana",
    countryPathName: "botswana-search-export",
    countryName: "Botswana Exports",
    continent: "AFRICA",
    dataSource: "botswana exports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },
      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
    ],
  },
  ci_import: {
    country_small: "ivory coast",
    country_caps: "IVORY COAST",
    product_id: "trademo_CI",
    country_CamelCase: "Ivory Coast",
    countryCode: "CI",
    countryCodeFlag: "CI",
    countryShortHand: "ivory-coast",
    compareProduct: "_ci_",
    countryType: "import",
    manyCountryType: "imports",
    countryTypeCode: "I",
    redirectionID: "ci_imports",
    analyticsCountryID: "IVORY-COAST-IMPORTS",
    localProduct: "intel-ivory-coast",
    countryUrlDashboard: "country=ivory-coast",
    countryPathName: "ivory-coast-search-import",
    countryName: "Ivory Coast Imports",
    continent: "AFRICA",
    dataSource: "ivory coast imports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },

      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
    ],
  },
  ci_export: {
    country_small: "ivory coast",
    country_caps: "IVORY COAST",
    product_id: "trademo_CI",
    country_CamelCase: "Ivory Coast",
    countryCode: "CI",
    countryCodeFlag: "CI",
    countryShortHand: "ivory-coast",
    compareProduct: "_ci_",
    countryType: "export",
    manyCountryType: "exports",
    countryTypeCode: "E",
    redirectionID: "ci_exports",
    analyticsCountryID: "IVORY-COAST-EXPORTS",
    localProduct: "intel-ivory-coast",
    countryUrlDashboard: "country=ivory-coast",
    countryPathName: "ivory-coast-search-export",
    countryName: "Ivory Coast Exports",
    continent: "AFRICA",
    dataSource: "ivory coast exports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },

      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
    ],
  },
  uz_export: {
    country_small: "uzbekistan",
    country_caps: "UZBEKISTAN",
    product_id: "trademo_UZ",
    country_CamelCase: "Uzbekistan",
    countryCode: "UZ",
    countryCodeFlag: "UZ",
    compareProduct: "_uz_",
    countryType: "export",
    manyCountryType: "exports",
    countryTypeCode: "E",
    redirectionID: "uz_exports",
    analyticsCountryID: "UZBEKISTAN-EXPORTS",
    localProduct: "intel-uzbekistan",
    countryUrlDashboard: "country=uzbekistan",
    countryPathName: "uzbekistan-search-export",
    countryName: "Uzbekistan Exports",
    continent: "ASIA",
    dataSource: "uzbekistan exports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },
      //
      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
    ],
  },
  uz_import: {
    country_small: "uzbekistan",
    country_caps: "UZBEKISTAN",
    product_id: "trademo_UZ",
    country_CamelCase: "Uzbekistan",
    countryCode: "UZ",
    countryCodeFlag: "UZ",
    compareProduct: "_uz_",
    countryType: "import",
    manyCountryType: "imports",
    countryTypeCode: "I",
    redirectionID: "uz_imports",
    analyticsCountryID: "UZBEKISTAN-IMPORTS",
    localProduct: "intel-uzbekistan",
    countryUrlDashboard: "country=uzbekistan",
    countryPathName: "uzbekistan-search-import",
    countryName: "Uzbekistan Imports",
    continent: "ASIA",
    dataSource: "uzbekistan imports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },
      //
      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
    ],
  },
  lk_import: {
    country_small: "sri lanka",
    country_caps: "SRI LANKA",
    product_id: "trademo_LK",
    country_CamelCase: "Sri Lanka",
    countryCode: "LK",
    countryCodeFlag: "LK",
    countryShortHand: "sri-lanka",
    compareProduct: "_lk_",
    countryType: "import",
    manyCountryType: "imports",
    countryTypeCode: "I",
    redirectionID: "lk_imports",
    analyticsCountryID: "SRI_LANKA-IMPORTS",
    localProduct: "intel-sri-lanka",
    countryUrlDashboard: "country=sri-lanka",
    countryPathName: "sri-lanka-search-import",
    countryName: "Sri Lanka Imports",
    continent: "ASIA",
    dataSource: "sri lanka imports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },
      //
      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
    ],
  },
  lk_export: {
    country_small: "sri lanka",
    country_caps: "SRI LANKA",
    product_id: "trademo_LK",
    country_CamelCase: "Sri Lanka",
    countryCode: "LK",
    countryCodeFlag: "LK",
    countryShortHand: "sri-lanka",
    compareProduct: "_lk_",
    countryType: "export",
    manyCountryType: "exports",
    countryTypeCode: "E",
    redirectionID: "lk_exports",
    analyticsCountryID: "SRI_LANKA-EXPORTS",
    localProduct: "intel-sri-lanka",
    countryUrlDashboard: "country=sri-lanka",
    countryPathName: "sri-lanka-search-export",
    countryName: "Sri Lanka Exports",
    continent: "ASIA",
    dataSource: "sri lanka exports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },
      //
      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
    ],
  },
  et_import: {
    country_small: "ethiopia",
    country_caps: "ETHIOPIA",
    product_id: "trademo_ET",
    country_CamelCase: "Ethiopia",
    countryCode: "ET",
    countryCodeFlag: "ET",
    countryShortHand: "et",
    compareProduct: "_et_",
    countryType: "import",
    manyCountryType: "imports",
    countryTypeCode: "I",
    redirectionID: "et_imports",
    analyticsCountryID: "ETHIOPIA-IMPORTS",
    localProduct: "intel-ethiopia",
    countryUrlDashboard: "country=et",
    countryPathName: "ethiopia-search-import",
    countryName: "Ethiopia Imports",
    coProductsUrl: "product-trends",
    continent: "AFRICA",
    dataSource: "ethiopia imports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      // { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
    ],
  },
  et_export: {
    country_small: "ethiopia",
    country_caps: "ETHIOPIA",
    product_id: "trademo_ET",
    country_CamelCase: "Ethiopia",
    countryCode: "ET",
    countryCodeFlag: "ET",
    countryShortHand: "et",
    compareProduct: "_et_",
    countryType: "export",
    manyCountryType: "exports",
    countryTypeCode: "E",
    redirectionID: "et_exports",
    analyticsCountryID: "ETHIOPIA-EXPORTS",
    localProduct: "intel-ethiopia",
    countryUrlDashboard: "country=et",
    countryPathName: "ethiopia-search-export",
    countryName: "Ethiopia Exports",
    coProductsUrl: "product-trends",
    continent: "AFRICA",
    dataSource: "ethiopia exports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      // { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
    ],
  },
  cr_import: {
    country_small: "costa rica",
    country_caps: "COSTA RICA",
    product_id: "trademo_CR",
    country_CamelCase: "Costa Rica",
    countryCode: "CR",
    countryCodeFlag: "CR",
    countryShortHand: "costa-rica",
    compareProduct: "_cr_",
    countryType: "import",
    manyCountryType: "imports",
    countryTypeCode: "I",
    redirectionID: "cr_imports",
    analyticsCountryID: "COSTA-RICA-IMPORTS",
    localProduct: "intel-costa-rica",
    countryUrlDashboard: "country=costa-rica",
    countryPathName: "costa-rica-search-import",
    countryName: "Costa Rica Imports",
    continent: "CSA",
    dataSource: "costa rica imports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },
      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
    ],
  },
  cr_export: {
    country_small: "costa rica",
    country_caps: "COSTA RICA",
    product_id: "trademo_CR",
    country_CamelCase: "Costa Rica",
    countryCode: "CR",
    countryCodeFlag: "CR",
    countryShortHand: "costa-rica",
    compareProduct: "_cr_",
    countryType: "export",
    manyCountryType: "exports",
    countryTypeCode: "E",
    redirectionID: "cr_exports",
    analyticsCountryID: "COSTA-RICA-EXPORTS",
    localProduct: "intel-costa-rica",
    countryUrlDashboard: "country=costa-rica",
    countryPathName: "costa-rica-search-export",
    countryName: "Costa Rica Exports",
    continent: "CSA",
    dataSource: "costa rica exports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },
      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
    ],
  },
  py_import: {
    country_small: "paraguay",
    country_caps: "PARAGUAY",
    product_id: "trademo_PY",
    country_CamelCase: "Paraguay",
    countryCode: "PY",
    countryCodeFlag: "PY",
    compareProduct: "_py_",
    countryType: "import",
    manyCountryType: "imports",
    countryTypeCode: "I",
    redirectionID: "py_imports",
    analyticsCountryID: "PARAGUAY-IMPORTS",
    localProduct: "intel-paraguay",
    countryUrlDashboard: "country=paraguay",
    countryPathName: "paraguay-search-import",
    countryName: "Paraguay Imports",
    continent: "CSA",
    dataSource: "paraguay imports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },
      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
    ],
  },
  py_export: {
    country_small: "paraguay",
    country_caps: "PARAGUAY",
    product_id: "trademo_PY",
    country_CamelCase: "Paraguay",
    countryCode: "PY",
    countryCodeFlag: "PY",
    compareProduct: "_py_",
    countryType: "export",
    manyCountryType: "exports",
    countryTypeCode: "E",
    redirectionID: "py_exports",
    analyticsCountryID: "PARAGUAY-EXPORTS",
    localProduct: "intel-paraguay",
    countryUrlDashboard: "country=paraguay",
    countryPathName: "paraguay-search-export",
    countryName: "Paraguay Exports",
    continent: "SOUTH AMERICA",
    dataSource: "paraguay exports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },
      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
    ],
  },
  ug_import: {
    country_small: "uganda",
    country_caps: "UGANDA",
    product_id: "trademo_UG",
    country_CamelCase: "Uganda",
    countryCode: "UG",
    countryCodeFlag: "UG",
    compareProduct: "_ug_",
    countryType: "import",
    manyCountryType: "imports",
    countryTypeCode: "I",
    redirectionID: "ug_imports",
    analyticsCountryID: "UGANDA-IMPORTS",
    localProduct: "intel-uganda",
    countryUrlDashboard: "country=uganda",
    countryPathName: "uganda-search-import",
    countryName: "Uganda Imports",
    continent: "AFRICA",
    dataSource: "uganda imports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },
      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
    ],
  },
  ug_export: {
    country_small: "uganda",
    country_caps: "UGANDA",
    product_id: "trademo_UG",
    country_CamelCase: "Uganda",
    countryCode: "UG",
    countryCodeFlag: "UG",
    compareProduct: "_ug_",
    countryType: "export",
    manyCountryType: "exports",
    countryTypeCode: "E",
    redirectionID: "ug_exports",
    analyticsCountryID: "UGANDA-EXPORTS",
    localProduct: "intel-uganda",
    countryUrlDashboard: "country=uganda",
    countryPathName: "uganda-search-export",
    countryName: "Uganda Exports",
    continent: "AFRICA",
    dataSource: "uganda exports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },
      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
    ],
  },
  sg_import: {
    country_small: "singapore",
    country_caps: "SINGAPORE",
    product_id: "trademo_SG",
    country_CamelCase: "Singapore",
    countryCode: "SG",
    countryCodeFlag: "SG",
    compareProduct: "_sg_",
    countryType: "import",
    manyCountryType: "imports",
    countryTypeCode: "I",
    redirectionID: "sg_imports",
    analyticsCountryID: "SINGAPORE-IMPORTS",
    localProduct: "intel-singapore",
    countryUrlDashboard: "country=singapore",
    countryPathName: "singapore-search-import-mirror",
    countryName: "Singapore Imports (Mirror)",
    continent: "MIRROR",
    dataSource: "singapore imports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },
      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
      { value: searchPhraseDictionary.ports, label: "Ports", placeHolder: "Search upto 20 Ports’s name", pillColor: "#de1368" },
    ],
  },
  sg_export: {
    country_small: "singapore",
    country_caps: "SINGAPORE",
    product_id: "trademo_SG",
    country_CamelCase: "Singapore",
    countryCode: "SG",
    countryCodeFlag: "SG",
    compareProduct: "_sg_",
    countryType: "export",
    manyCountryType: "exports",
    countryTypeCode: "E",
    redirectionID: "sg_exports",
    analyticsCountryID: "SINGAPORE-EXPORTS",
    localProduct: "intel-singapore",
    countryUrlDashboard: "country=singapore",
    countryPathName: "singapore-search-export-mirror",
    countryName: "Singapore Exports (Mirror)",
    continent: "MIRROR",
    dataSource: "Singapore exports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },
      { value: searchPhraseDictionary.ports, label: "Ports", placeHolder: "Search upto 20 Ports’s name", pillColor: "#de1368" },
      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
    ],
  },
  ae_import: {
    country_small: "united arab emirates",
    country_caps: "UNITED ARAB EMIRATES",
    product_id: "trademo_AE",
    country_CamelCase: "United Arab Emirates",
    countryCode: "AE",
    countryCodeFlag: "AE",
    countryShortHand: "united-arab-emirates",
    compareProduct: "_ae_",
    countryType: "import",
    manyCountryType: "imports",
    countryTypeCode: "I",
    redirectionID: "ae_imports",
    analyticsCountryID: "UNITED-ARAB-EMIRATES-IMPORTS",
    localProduct: "intel-united-arab-emirates",
    countryUrlDashboard: "country=united-arab-emirates",
    countryPathName: "uae-search-import-mirror",
    countryName: "UAE Imports (Mirror)",
    continent: "MIRROR",
    dataSource: "united arab emirates imports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },
      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
      { value: searchPhraseDictionary.ports, label: "Ports", placeHolder: "Search upto 20 Ports’s name", pillColor: "#de1368" },
    ],
  },
  ae_export: {
    country_small: "united arab emirates",
    country_caps: "UNITED ARAB EMIRATES",
    product_id: "trademo_AE",
    country_CamelCase: "United Arab Emirates",
    countryCode: "AE",
    countryCodeFlag: "AE",
    countryShortHand: "united-arab-emirates",
    compareProduct: "_ae_",
    countryType: "export",
    manyCountryType: "exports",
    countryTypeCode: "E",
    redirectionID: "ae_exports",
    analyticsCountryID: "UNITED-ARAB-EMIRATES-EXPORTS",
    localProduct: "intel-united-arab-emirates",
    countryUrlDashboard: "country=united-arab-emirates",
    countryPathName: "uae-search-export-mirror",
    countryName: "UAE Exports (Mirror)",
    continent: "MIRROR",
    dataSource: "united arab emirates exports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },
      { value: searchPhraseDictionary.ports, label: "Ports", placeHolder: "Search upto 20 Ports’s name", pillColor: "#de1368" },
      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
    ],
  },
  my_import: {
    country_small: "malaysia",
    country_caps: "MALAYSIA",
    product_id: "trademo_MY",
    country_CamelCase: "Malaysia",
    countryCode: "MY",
    countryCodeFlag: "MY",
    compareProduct: "_my_",
    countryType: "import",
    manyCountryType: "imports",
    countryTypeCode: "I",
    redirectionID: "my_imports",
    analyticsCountryID: "MALAYSIA-IMPORTS",
    localProduct: "intel-malaysia",
    countryUrlDashboard: "country=malaysia",
    countryPathName: "malaysia-search-import-mirror",
    countryName: "Malaysia Imports (Mirror)",
    continent: "MIRROR",
    dataSource: "malaysia imports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },
      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
      { value: searchPhraseDictionary.ports, label: "Ports", placeHolder: "Search upto 20 Ports’s name", pillColor: "#de1368" },
    ],
  },
  my_export: {
    country_small: "malaysia",
    country_caps: "MALAYSIA",
    product_id: "trademo_MY",
    country_CamelCase: "Malaysia",
    countryCode: "MY",
    countryCodeFlag: "MY",
    compareProduct: "_my_",
    countryType: "export",
    manyCountryType: "exports",
    countryTypeCode: "E",
    redirectionID: "my_exports",
    analyticsCountryID: "MALAYSIA-EXPORTS",
    localProduct: "intel-malaysia",
    countryUrlDashboard: "country=malaysia",
    countryPathName: "malaysia-search-export-mirror",
    countryName: "Malaysia Exports (Mirror)",
    continent: "MIRROR",
    dataSource: "malaysia exports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },
      { value: searchPhraseDictionary.ports, label: "Ports", placeHolder: "Search upto 20 Ports’s name", pillColor: "#de1368" },
      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
    ],
  },
  th_import: {
    country_small: "thailand",
    country_caps: "THAILAND",
    product_id: "trademo_TH",
    country_CamelCase: "Thailand",
    countryCode: "TH",
    countryCodeFlag: "TH",
    compareProduct: "_th_",
    countryType: "import",
    manyCountryType: "imports",
    countryTypeCode: "I",
    redirectionID: "th_imports",
    analyticsCountryID: "THAILAND-IMPORTS",
    localProduct: "intel-thailand",
    countryUrlDashboard: "country=thailand",
    countryPathName: "thailand-search-import-mirror",
    countryName: "Thailand Imports (Mirror)",
    continent: "MIRROR",
    dataSource: "thailand imports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },
      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
      { value: searchPhraseDictionary.ports, label: "Ports", placeHolder: "Search upto 20 Ports’s name", pillColor: "#de1368" },
    ],
  },
  th_export: {
    country_small: "thailand",
    country_caps: "THAILAND",
    product_id: "trademo_TH",
    country_CamelCase: "Thailand",
    countryCode: "TH",
    countryCodeFlag: "TH",
    compareProduct: "_th_",
    countryType: "export",
    manyCountryType: "exports",
    countryTypeCode: "E",
    redirectionID: "th_exports",
    analyticsCountryID: "THAILAND-EXPORTS",
    localProduct: "intel-thailand",
    countryUrlDashboard: "country=thailand",
    countryPathName: "thailand-search-export-mirror",
    countryName: "Thailand Exports (Mirror)",
    continent: "MIRROR",
    dataSource: "thailand exports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },
      { value: searchPhraseDictionary.ports, label: "Ports", placeHolder: "Search upto 20 Ports’s name", pillColor: "#de1368" },
      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
    ],
  },
  tr_import: {
    country_small: "turkey",
    country_caps: "TURKEY",
    product_id: "trademo_TR",
    country_CamelCase: "Turkey",
    countryCode: "TR",
    countryCodeFlag: "TR",
    compareProduct: "_tr_",
    countryType: "import",
    manyCountryType: "imports",
    countryTypeCode: "I",
    redirectionID: "tr_imports",
    analyticsCountryID: "TURKEY-IMPORTS",
    localProduct: "intel-turkey",
    countryUrlDashboard: "country=turkey",
    countryPathName: "turkey-search-import-mirror",
    countryName: "Turkey Imports (Mirror)",
    continent: "MIRROR",
    dataSource: "turkey imports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },
      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
      { value: searchPhraseDictionary.ports, label: "Ports", placeHolder: "Search upto 20 Ports’s name", pillColor: "#de1368" },
    ],
  },
  tr_export: {
    country_small: "turkey",
    country_caps: "TURKEY",
    product_id: "trademo_TR",
    country_CamelCase: "Turkey",
    countryCode: "TR",
    countryCodeFlag: "TR",
    compareProduct: "_tr_",
    countryType: "export",
    manyCountryType: "exports",
    countryTypeCode: "E",
    redirectionID: "tr_exports",
    analyticsCountryID: "TURKEY-EXPORTS",
    localProduct: "intel-turkey",
    countryUrlDashboard: "country=turkey",
    countryPathName: "turkey-search-export-mirror",
    countryName: "Turkey Exports (Mirror)",
    continent: "MIRROR",
    dataSource: "turkey exports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },
      { value: searchPhraseDictionary.ports, label: "Ports", placeHolder: "Search upto 20 Ports’s name", pillColor: "#de1368" },
      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
    ],
  },
  au_import: {
    country_small: "australia",
    country_caps: "AUSTRALIA",
    product_id: "trademo_AU",
    country_CamelCase: "Australia",
    countryCode: "AU",
    countryCodeFlag: "AU",
    compareProduct: "_au_",
    countryType: "import",
    manyCountryType: "imports",
    countryTypeCode: "I",
    redirectionID: "au_imports",
    analyticsCountryID: "AUSTRALIA-IMPORTS",
    localProduct: "intel-australia",
    countryUrlDashboard: "country=australia",
    countryPathName: "australia-search-import-mirror",
    countryName: "Australia Imports (Mirror)",
    continent: "MIRROR",
    dataSource: "australia imports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },
      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
      { value: searchPhraseDictionary.ports, label: "Ports", placeHolder: "Search upto 20 Ports’s name", pillColor: "#de1368" },
    ],
  },
  au_export: {
    country_small: "australia",
    country_caps: "AUSTRALIA",
    product_id: "trademo_AU",
    country_CamelCase: "Australia",
    countryCode: "AU",
    countryCodeFlag: "AU",
    compareProduct: "_au_",
    countryType: "export",
    manyCountryType: "exports",
    countryTypeCode: "E",
    redirectionID: "au_exports",
    analyticsCountryID: "AUSTRALIA-EXPORTS",
    localProduct: "intel-australia",
    countryUrlDashboard: "country=australia",
    countryPathName: "australia-search-export-mirror",
    countryName: "Australia Exports (Mirror)",
    continent: "MIRROR",
    dataSource: "australia exports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },
      { value: searchPhraseDictionary.ports, label: "Ports", placeHolder: "Search upto 20 Ports’s name", pillColor: "#de1368" },
      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
    ],
  },
  tw_import: {
    country_small: "taiwan",
    country_caps: "TAIWAN",
    product_id: "trademo_TW",
    country_CamelCase: "Taiwan",
    countryCode: "TW",
    countryCodeFlag: "TW",
    compareProduct: "_tw_",
    countryType: "import",
    manyCountryType: "imports",
    countryTypeCode: "I",
    redirectionID: "tw_imports",
    analyticsCountryID: "TAIWAN-IMPORTS",
    localProduct: "intel-taiwan",
    countryUrlDashboard: "country=taiwan",
    countryPathName: "taiwan-search-import-mirror",
    countryName: "Taiwan Imports (Mirror)",
    continent: "MIRROR",
    dataSource: "taiwan imports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },
      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
      { value: searchPhraseDictionary.ports, label: "Ports", placeHolder: "Search upto 20 Ports’s name", pillColor: "#de1368" },
    ],
  },
  tw_export: {
    country_small: "taiwan",
    country_caps: "TAIWAN",
    product_id: "trademo_TW",
    country_CamelCase: "Taiwan",
    countryCode: "TW",
    countryCodeFlag: "TW",
    compareProduct: "_tw_",
    countryType: "export",
    manyCountryType: "exports",
    countryTypeCode: "E",
    redirectionID: "tw_exports",
    analyticsCountryID: "TAIWAN-EXPORTS",
    localProduct: "intel-taiwan",
    countryUrlDashboard: "country=taiwan",
    countryPathName: "taiwan-search-export-mirror",
    countryName: "Taiwan Exports (Mirror)",
    continent: "MIRROR",
    dataSource: "taiwan exports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },
      { value: searchPhraseDictionary.ports, label: "Ports", placeHolder: "Search upto 20 Ports’s name", pillColor: "#de1368" },
      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
    ],
  },
  sa_import: {
    country_small: "saudi arabia",
    country_caps: "SAUDI ARABIA",
    product_id: "trademo_SA",
    country_CamelCase: "Saudi Arabia",
    countryCode: "SA",
    countryCodeFlag: "SA",
    countryShortHand: "saudi-arabia",
    compareProduct: "_sa_",
    countryType: "import",
    manyCountryType: "imports",
    countryTypeCode: "I",
    redirectionID: "sa_imports",
    analyticsCountryID: "SAUDI-ARABIA-IMPORTS",
    localProduct: "intel-saudi-arabia",
    countryUrlDashboard: "country=saudi-arabia",
    countryPathName: "saudi-arabia-search-import-mirror",
    countryName: "Saudi Arabia Imports (Mirror)",
    continent: "MIRROR",
    dataSource: "saudi arabia imports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },
      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
      { value: searchPhraseDictionary.ports, label: "Ports", placeHolder: "Search upto 20 Ports’s name", pillColor: "#de1368" },
    ],
  },
  sa_export: {
    country_small: "saudi arabia",
    country_caps: "SAUDI ARABIA",
    product_id: "trademo_SA",
    country_CamelCase: "Saudi Arabia",
    countryCode: "SA",
    countryCodeFlag: "SA",
    countryShortHand: "saudi-arabia",
    compareProduct: "_sa_",
    countryType: "export",
    manyCountryType: "exports",
    countryTypeCode: "E",
    redirectionID: "sa_exports",
    analyticsCountryID: "SAUDI-ARABIA-EXPORTS",
    localProduct: "intel-saudi-arabia",
    countryUrlDashboard: "country=saudi-arabia",
    countryPathName: "saudi-arabia-search-export-mirror",
    countryName: "Saudi Arabia Exports (Mirror)",
    continent: "MIRROR",
    dataSource: "saudi arabia exports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },
      { value: searchPhraseDictionary.ports, label: "Ports", placeHolder: "Search upto 20 Ports’s name", pillColor: "#de1368" },
      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
    ],
  },
  ca_import: {
    country_small: "canada",
    country_caps: "CANADA",
    product_id: "trademo_CA",
    country_CamelCase: "Canada",
    countryCode: "CA",
    countryCodeFlag: "CA",
    compareProduct: "_ca_",
    countryType: "import",
    manyCountryType: "imports",
    countryTypeCode: "I",
    redirectionID: "ca_imports",
    analyticsCountryID: "CANADA-IMPORTS",
    localProduct: "intel-canada",
    countryUrlDashboard: "country=canada",
    countryPathName: "canada-search-import-mirror",
    countryName: "Canada Imports (Mirror)",
    continent: "MIRROR",
    dataSource: "canada imports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },
      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
      { value: searchPhraseDictionary.ports, label: "Ports", placeHolder: "Search upto 20 Ports’s name", pillColor: "#de1368" },
    ],
  },
  ca_export: {
    country_small: "canada",
    country_caps: "CANADA",
    product_id: "trademo_CA",
    country_CamelCase: "Canada",
    countryCode: "CA",
    countryCodeFlag: "CA",
    compareProduct: "_ca_",
    countryType: "export",
    manyCountryType: "exports",
    countryTypeCode: "E",
    redirectionID: "ca_exports",
    analyticsCountryID: "CANADA-EXPORTS",
    localProduct: "intel-canada",
    countryUrlDashboard: "country=canada",
    countryPathName: "canada-search-export-mirror",
    countryName: "Canada Exports (Mirror)",
    continent: "MIRROR",
    dataSource: "canada exports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },
      { value: searchPhraseDictionary.ports, label: "Ports", placeHolder: "Search upto 20 Ports’s name", pillColor: "#de1368" },
      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
    ],
  },
  de_import: {
    country_small: "germany",
    country_caps: "GERMANY",
    product_id: "trademo_DE",
    country_CamelCase: "Germany",
    countryCode: "DE",
    countryCodeFlag: "DE",
    compareProduct: "_de_",
    countryType: "import",
    manyCountryType: "imports",
    countryTypeCode: "I",
    redirectionID: "de_imports",
    analyticsCountryID: "GERMANY-IMPORTS",
    localProduct: "intel-germany",
    countryUrlDashboard: "country=germany",
    countryPathName: "germany-search-import-mirror",
    countryName: "Germany Imports (Mirror)",
    continent: "MIRROR",
    dataSource: "germany imports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },
      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
      { value: searchPhraseDictionary.ports, label: "Ports", placeHolder: "Search upto 20 Ports’s name", pillColor: "#de1368" },
    ],
  },
  de_export: {
    country_small: "germany",
    country_caps: "GERMANY",
    product_id: "trademo_DE",
    country_CamelCase: "Germany",
    countryCode: "DE",
    countryCodeFlag: "DE",
    compareProduct: "_de_",
    countryType: "export",
    manyCountryType: "exports",
    countryTypeCode: "E",
    redirectionID: "de_exports",
    analyticsCountryID: "GERMANY-EXPORTS",
    localProduct: "intel-germany",
    countryUrlDashboard: "country=germany",
    countryPathName: "germany-search-export-mirror",
    countryName: "Germany Exports (Mirror)",
    continent: "MIRROR",
    dataSource: "germany exports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },
      { value: searchPhraseDictionary.ports, label: "Ports", placeHolder: "Search upto 20 Ports’s name", pillColor: "#de1368" },
      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
    ],
  },
  hk_import: {
    country_small: "hong kong",
    country_caps: "HONG KONG",
    product_id: "trademo_HK",
    country_CamelCase: "Hong Kong",
    countryCode: "HK",
    countryCodeFlag: "HK",
    compareProduct: "_hk_",
    countryType: "import",
    manyCountryType: "imports",
    countryTypeCode: "I",
    redirectionID: "hk_imports",
    analyticsCountryID: "HONG-KONG-IMPORTS",
    localProduct: "intel-hong-kong",
    countryUrlDashboard: "country=hong-kong",
    countryPathName: "hong-kong-search-import-mirror",
    countryName: "Hong Kong Imports (Mirror)",
    continent: "MIRROR",
    dataSource: "hong kong imports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },
      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
      { value: searchPhraseDictionary.ports, label: "Ports", placeHolder: "Search upto 20 Ports’s name", pillColor: "#de1368" },
    ],
  },
  hk_export: {
    country_small: "hong kong",
    country_caps: "HONG KONG",
    product_id: "trademo_HK",
    country_CamelCase: "Hong Kong",
    countryCode: "HK",
    countryCodeFlag: "HK",
    compareProduct: "_hk_",
    countryType: "export",
    manyCountryType: "exports",
    countryTypeCode: "E",
    redirectionID: "hk_exports",
    analyticsCountryID: "HONG-KONG-EXPORTS",
    localProduct: "intel-hong-kong",
    countryUrlDashboard: "country=hong-kong",
    countryPathName: "hong-kong-search-export-mirror",
    countryName: "Hong Kong Exports (Mirror)",
    continent: "MIRROR",
    dataSource: "hong kong exports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },
      { value: searchPhraseDictionary.ports, label: "Ports", placeHolder: "Search upto 20 Ports’s name", pillColor: "#de1368" },
      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
    ],
  },
  jp_import: {
    country_small: "japan",
    country_caps: "JAPAN",
    product_id: "trademo_JP",
    country_CamelCase: "Japan",
    countryCode: "JP",
    countryCodeFlag: "JP",
    compareProduct: "_jp_",
    countryType: "import",
    manyCountryType: "imports",
    countryTypeCode: "I",
    redirectionID: "jp_imports",
    analyticsCountryID: "JAPAN-IMPORTS",
    localProduct: "intel-japan",
    countryUrlDashboard: "country=japan",
    countryPathName: "japan-search-import-mirror",
    countryName: "Japan Imports (Mirror)",
    continent: "MIRROR",
    dataSource: "japan imports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },
      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
      { value: searchPhraseDictionary.ports, label: "Ports", placeHolder: "Search upto 20 Ports’s name", pillColor: "#de1368" },
    ],
  },
  jp_export: {
    country_small: "japan",
    country_caps: "JAPAN",
    product_id: "trademo_JP",
    country_CamelCase: "Japan",
    countryCode: "JP",
    countryCodeFlag: "JP",
    compareProduct: "_jp_",
    countryType: "export",
    manyCountryType: "exports",
    countryTypeCode: "E",
    redirectionID: "jp_exports",
    analyticsCountryID: "JAPAN-EXPORTS",
    localProduct: "intel-japan",
    countryUrlDashboard: "country=japan",
    countryPathName: "japan-search-export-mirror",
    countryName: "Japan Exports (Mirror)",
    continent: "MIRROR",
    dataSource: "japan exports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },
      { value: searchPhraseDictionary.ports, label: "Ports", placeHolder: "Search upto 20 Ports’s name", pillColor: "#de1368" },
      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
    ],
  },
  kr_import: {
    country_small: "south korea",
    country_caps: "SOUTH KOREA",
    product_id: "trademo_KR",
    country_CamelCase: "South Korea",
    countryCode: "KR",
    countryCodeFlag: "KR",
    compareProduct: "_kr_",
    countryType: "import",
    manyCountryType: "imports",
    countryTypeCode: "I",
    redirectionID: "kr_imports",
    analyticsCountryID: "SOUTH-KOREA-IMPORTS",
    localProduct: "intel-south-korea",
    countryUrlDashboard: "country=south-korea",
    countryPathName: "south-korea-search-import-mirror",
    countryName: "South Korea Imports (Mirror)",
    continent: "MIRROR",
    dataSource: "south korea imports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },
      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
      { value: searchPhraseDictionary.ports, label: "Ports", placeHolder: "Search upto 20 Ports’s name", pillColor: "#de1368" },
    ],
  },
  kr_export: {
    country_small: "south korea",
    country_caps: "SOUTH KOREA",
    product_id: "trademo_KR",
    country_CamelCase: "South Korea",
    countryCode: "KR",
    countryCodeFlag: "KR",
    compareProduct: "_kr_",
    countryType: "export",
    manyCountryType: "exports",
    countryTypeCode: "E",
    redirectionID: "kr_exports",
    analyticsCountryID: "SOUTH-KOREA-EXPORTS",
    localProduct: "intel-south-korea",
    countryUrlDashboard: "country=south-korea",
    countryPathName: "south-korea-search-export-mirror",
    countryName: "South Korea Exports (Mirror)",
    continent: "MIRROR",
    dataSource: "south korea exports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },
      { value: searchPhraseDictionary.ports, label: "Ports", placeHolder: "Search upto 20 Ports’s name", pillColor: "#de1368" },
      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
    ],
  },
  middleeast_import: {
    country_small: "middle east",
    country_caps: "MIDDLE EAST",
    product_id: "trademo_MIDDLEEAST",
    country_CamelCase: "Middle East",
    countryCode: "middleeast",
    countryCodeFlag: "middleeast",
    countryShortHand: "middle-east",
    compareProduct: "_middleeast_",
    countryType: "import",
    manyCountryType: "imports",
    countryTypeCode: "I",
    redirectionID: "middleeast_imports",
    analyticsCountryID: "MIDDLE-EAST-IMPORTS",
    localProduct: "intel-middle-east",
    countryUrlDashboard: "country=middle-east",
    countryPathName: "middle-east-search-import-mirror",
    countryName: "Middle East Imports (Mirror)",
    continent: "MIRROR",
    dataSource: "middle east imports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },
      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
      { value: searchPhraseDictionary.ports, label: "Ports", placeHolder: "Search upto 20 Ports’s name", pillColor: "#de1368" },
    ],
  },
  middleeast_export: {
    country_small: "middle east",
    country_caps: "MIDDLE EAST",
    product_id: "trademo_MIDDLEEAST",
    country_CamelCase: "Middle East",
    countryCode: "middleeast",
    countryCodeFlag: "middleeast",
    countryShortHand: "middle-east",
    compareProduct: "_middleeast_",
    countryType: "export",
    manyCountryType: "exports",
    countryTypeCode: "E",
    redirectionID: "middleeast_exports",
    analyticsCountryID: "MIDDLE-EAST-EXPORTS",
    localProduct: "intel-middle-east",
    countryUrlDashboard: "country=middle-east",
    countryPathName: "middle-east-search-export-mirror",
    countryName: "Middle East Exports (Mirror)",
    continent: "MIRROR",
    dataSource: "middle east Exports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },
      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
      { value: searchPhraseDictionary.ports, label: "Ports", placeHolder: "Search upto 20 Ports’s name", pillColor: "#de1368" },
    ],
  },
  eu_import: {
    country_small: "europe",
    country_caps: "EUROPE",
    product_id: "trademo_EU",
    country_CamelCase: "Europe",
    countryCode: "eu",
    countryCodeFlag: "eu",
    countryShortHand: "europe",
    compareProduct: "_europe_",
    countryType: "import",
    manyCountryType: "imports",
    countryTypeCode: "I",
    redirectionID: "eu_imports",
    analyticsCountryID: "EUROPE-IMPORTS",
    localProduct: "intel-europe",
    countryUrlDashboard: "country=europe",
    countryPathName: "europe-search-import-mirror",
    countryName: "Europe Imports (Mirror)",
    continent: "MIRROR",
    dataSource: "europe imports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },
      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
      { value: searchPhraseDictionary.ports, label: "Ports", placeHolder: "Search upto 20 Ports’s name", pillColor: "#de1368" },
    ],
  },
  eu_export: {
    country_small: "europe",
    country_caps: "EUROPE",
    product_id: "trademo_EU",
    country_CamelCase: "Europe",
    countryCode: "eu",
    countryCodeFlag: "eu",
    countryShortHand: "europe",
    compareProduct: "_europe_",
    countryType: "export",
    manyCountryType: "exports",
    countryTypeCode: "I",
    redirectionID: "eu_exports",
    analyticsCountryID: "EUROPE-EXPORTS",
    localProduct: "intel-europe",
    countryUrlDashboard: "country=europe",
    countryPathName: "europe-search-export-mirror",
    countryName: "Europe Exports (Mirror)",
    continent: "MIRROR",
    dataSource: "europe exports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },
      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
      { value: searchPhraseDictionary.ports, label: "Ports", placeHolder: "Search upto 20 Ports’s name", pillColor: "#de1368" },
    ],
  },
  usm_import: {
    // US Import
    country_small: "us mirror",
    country_caps: "US MIRROR",
    product_id: "trademo_USM",
    country_CamelCase: "United States",
    countryCode: "USM",
    countryCodeFlag: "USM",
    countryShortHand: "USM",
    compareProduct: "_us-mirror_",
    countryType: "import",
    manyCountryType: "imports",
    countryTypeCode: "I",
    redirectionID: "usm_imports",
    analyticsCountryID: "US-MIRROR-IMPORTS",
    localProduct: "intel-us",
    countryUrlDashboard: "country=usm",
    countryPathName: "us-search-import-mirror",
    countryName: "US Imports (Non-Maritime)",
    continent: "MIRROR",
    dataSource: "us mirror imports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },
      { value: searchPhraseDictionary.logistics, label: "Logistics", placeHolder: "Search upto 20 Logistics by name or SCAC", pillColor: "#178add" },
      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
      { value: searchPhraseDictionary.ports, label: "Ports", placeHolder: "Search upto 20 Ports’s name", pillColor: "#de1368" },
    ],
  },
  usm_export: {
    // US Export
    country_small: "us mirror",
    country_caps: "US MIRROR",
    product_id: "trademo_USM",
    country_CamelCase: "United States",
    countryCode: "USM",
    countryCodeFlag: "USM",
    countryShortHand: "USM",
    compareProduct: "_us-mirror_",
    countryType: "export",
    manyCountryType: "exports",
    countryTypeCode: "E",
    redirectionID: "usm_exports",
    analyticsCountryID: "US-MIRROR-EXPORTS",
    localProduct: "intel-us",
    countryUrlDashboard: "country=usm",
    countryPathName: "us-search-export-mirror",
    countryName: "US Exports (Non-Maritime)",
    continent: "MIRROR",
    dataSource: "us mirror exports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },
      { value: searchPhraseDictionary.logistics, label: "Logistics", placeHolder: "Search upto 20 Logistics by name or SCAC", pillColor: "#178add" },
      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
      { value: searchPhraseDictionary.ports, label: "Ports", placeHolder: "Search upto 20 Ports’s name", pillColor: "#de1368" },
    ],
  },
  mxm_import: {
    // US Import
    country_small: "mexico maritime",
    country_caps: "MEXICO MARITIME",
    product_id: "trademo_MXM",
    country_CamelCase: "MEXICO",
    countryCode: "MXM",
    countryCodeFlag: "MXM",
    countryShortHand: "MXM",
    compareProduct: "_mx-maritime",
    countryType: "import",
    manyCountryType: "imports",
    countryTypeCode: "I",
    redirectionID: "mxm_imports",
    analyticsCountryID: "MEXICO-MARITIME-IMPORTS",
    localProduct: "intel-mxm",
    countryUrlDashboard: "country=mxm",
    countryPathName: "mx-search-import-maritime",
    countryName: "Mexico Imports (Maritime)",
    continent: "NA",
    dataSource: "mexico maritime imports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.importers, label: "Consignee", placeHolder: "Search upto 20 Consignee’s name or address", pillColor: "#2a3791" },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },
      { value: searchPhraseDictionary.logistics, label: "Logistics", placeHolder: "Search upto 20 Logistics by name or SCAC", pillColor: "#178add" },
      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
      { value: searchPhraseDictionary.ports, label: "Ports", placeHolder: "Search upto 20 Ports’s name", pillColor: "#de1368" },
    ],
  },
  mxm_export: {
    // US Export
    country_small: "mexico maritime",
    country_caps: "MEXICO MARITIME",
    product_id: "trademo_MXM",
    country_CamelCase: "Mexico",
    countryCode: "MXM",
    countryCodeFlag: "MXM",
    countryShortHand: "MXM",
    compareProduct: "_mx-maritime_",
    countryType: "export",
    manyCountryType: "exports",
    countryTypeCode: "E",
    redirectionID: "mxm_exports",
    analyticsCountryID: "MEXICO-MIRROR-EXPORTS",
    localProduct: "intel-mxm",
    countryUrlDashboard: "country=mxm",
    countryPathName: "mx-search-export-maritime",
    countryName: "Mexico Exports (Maritime)",
    continent: "NA",
    dataSource: "mexico maritime exports",
    defaultDropDown: [
      {
        value: searchPhraseDictionary.entire_bill_of_lading,
        label: "All Categories",
        placeHolder: "Type to search in all categories or choose from the category below",
      },
      { value: searchPhraseDictionary.exporters, label: "Shipper", placeHolder: "Search upto 20 Shipper's name or address", pillColor: "#07710b" },
      { value: searchPhraseDictionary.logistics, label: "Logistics", placeHolder: "Search upto 20 Logistics by name or SCAC", pillColor: "#178add" },
      { value: searchPhraseDictionary.product_hscode, label: "HS Code", placeHolder: "Search upto 20 Harmonised System Codes ", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.product_description, label: "Product", placeHolder: "Search for 20 commodities such as Apple, Laptops", pillColor: "#e30c0c" },
      { value: searchPhraseDictionary.chemical_description, label: "Chemicals", placeHolder: "Search upto 20 Chemical", pillColor: "#e3730c" },
      { value: searchPhraseDictionary.ports, label: "Ports", placeHolder: "Search upto 20 Ports’s name", pillColor: "#de1368" },
    ],
  },
};
